import React from 'react'
import Box, { BoxProps } from '../UI/Box'
import { Color } from '../../interfaces/designSystem'
import Flex from '@ui/Flex'
import Grid from '@ui/Grid'
import { IconType } from 'react-icons'

interface Props extends Omit<BoxProps, 'title'> {
  title?: React.ReactNode
  children?: React.ReactNode
  actions?: any
  innerProps?: BoxProps
  variant?: 'default' | 'big'
  subtitle?: React.ReactNode
  icon?: IconType
}

const Widget = ({
  title,
  subtitle,
  children,
  actions,
  innerProps,
  variant = 'default',
  icon: Icon,
  ...props
}: Props) => {
  return (
    <Box
      borderRadius={10}
      p={variant === 'big' ? 16 : 10}
      bg={Color.White}
      position="relative"
      {...props}
    >
      {Icon && (
        <Box
          position="absolute"
          right="0"
          bottom="0"
          width={102}
          color={Color.White_20}
          zIndex={0}
        >
          <Icon size="100%" />
        </Box>
      )}
      <Flex
        justifyContent="space-between"
        alignItems="flex-start"
        zIndex={1}
        position="relative"
      >
        {title && (
          <Box fontSize={18} pb={8}>
            {title}
          </Box>
        )}
        {!!actions?.length && (
          <Grid flow="column" gap={8} ml={8}>
            {actions}
          </Grid>
        )}
      </Flex>
      {subtitle && (
        <Box fontSize={14} color={Color.Grey_50} pb={8} zIndex={1} position="relative">
          {subtitle}
        </Box>
      )}
      <Box
        pt={(title || subtitle) && children ? 16 : 0}
        zIndex={1}
        position="relative"
        {...innerProps}
      >
        {children}
      </Box>
    </Box>
  )
}

export default Widget
